import { showCreateDemeanPopup } from "@/entities/bottom-popup"
import { triggerHapticImpact } from "@/shared/lib/telegram"

export function inviteFriend(): void {
	triggerHapticImpact("medium")
	showCreateDemeanPopup()
}
